import { defineMessages } from 'react-intl';

const translations = {
  page: {
    filesSection: {
      title: {
        id: 'files.title',
        defaultMessage: 'Files',
        description: 'Title of the files section',
      },
      button: {
        add: {
          label: {
            id: 'files.button.add.label',
            defaultMessage: 'Add',
            description: 'Label of the add button of the files section',
          },
        },
      },
      actions: {
        download: {
          label: {
            id: 'files.actions.download.label',
            defaultMessage: 'Download',
            description: 'Label of the download button in the files section',
          },
        },
        delete: {
          label: {
            id: 'files.actions.delete.label',
            defaultMessage: 'Delete',
            description: 'Label of the delete button in the files section',
          },
        },
        print: {
          label: {
            id: 'files.actions.print.label',
            defaultMessage: 'Print',
            description: 'Label of the print button in the files section',
          },
        },
        uploadToStorage: {
          label: {
            id: 'files.actions.uploadToStorage.label',
            defaultMessage: 'Upload to storage',
            description: 'Label of the upload to storage button in the files section',
          },
        },
      },
      emptyMessage: {
        id: 'files.emptyMessage',
        defaultMessage: 'No files',
        description: 'Empty message of the files section',
      },
    },
  },
  confirmDeleteFile: {
    title: {
      id: 'files.confirmDeleteFile.title',
      defaultMessage: 'Delete file',
      description: 'title of the confirm delete file dialog in the files section',
    },
    description: {
      id: 'files.confirmDeleteFile.description',
      defaultMessage: 'Are you sure you would like to delete this file?',
      description: 'description of the confirm delete file dialog in the files section',
    },
    buttons: {
      cancel: {
        id: 'files.confirmDeleteFile.buttons.cancel',
        defaultMessage: 'Cancel',
        description:
          'label of the cancel button of the confirm delete file dialog in the files section',
      },
      delete: {
        id: 'files.confirmDeleteFile.buttons.delete',
        defaultMessage: 'Delete',
        description:
          'label of the delete button of the confirm delete file dialog in the files section',
      },
    },
  },
  printFileProgressDialog: {
    description: {
      id: 'files.printFileProgressDialog.description',
      defaultMessage: 'Printing file...',
      description: 'Description of the print file progress dialog',
    },
  },
  printingFileFailedDialog: {
    title: {
      id: 'files.printingFileFailedDialog.title',
      defaultMessage: 'Printing the file failed',
      description: 'Title of the print file failed dialog',
    },
    message: {
      id: 'files.printingFileFailedDialog.message',
      defaultMessage: 'The file could not be printed',
      description: 'Message of the print file failed dialog',
    },
  },
  feedback: {
    fileDeleted: {
      id: 'files.feedback.fileDeleted',
      defaultMessage: 'File deleted',
      description: 'Success message of the file delete action in the files section',
    },
    fileNotDeleted: {
      id: 'files.feedback.fileNotDeleted',
      defaultMessage: 'File could not be deleted',
      description: 'Error message of the file delete action in the files section',
    },
    filePrinted: {
      id: 'files.feedback.filePrinted',
      defaultMessage: 'File printed',
      description: 'Success message of the file print action in the files section',
    },
    fileUploaded: {
      id: 'files.feedback.fileUploaded',
      defaultMessage: 'File uploaded to filesystem',
      description: 'Success message of the file upload action in the files section',
    },
    fileNotUploaded: {
      id: 'files.feedback.fileNotUploaded',
      defaultMessage: 'File could not be uploaded to filesystem',
      description: 'error message of the file upload action in the files section',
    },
  },
};

export default defineMessages(translations);
